'use client'
import React from 'react'
import CommonImage from "@/components/common/image/CommonImage";
import Image from 'next/image';
import { useSelector } from 'react-redux';

export default function AboutSection({siteSetting, bgClass='home-bg'}) {
  return (
    <section className={`about_Section ${bgClass} section_padding`}>
      <div className="container">

        <div className="section-content-wrap">
        <div className="section_title sm:mx-auto sm:text-center md:mb-6 mb-4">
          <h2 className="title flex items-center sm:justify-center gap-2">
            <span className="w-8 h-8">
              <CommonImage
                src="/images/admission-icon/about-icon.png"
                className="img-icon"
                alt="Book Icon"
              />
            </span>
            একনজরে ফোকাস
          </h2>
          <p className="short-des">
            ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
            গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে
            আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
          </p>
        </div>
          <div className="about-card-container">
            <div className="card-item item1">
             <div className='relative w-full h-full'>
               <Image
                src={'/images/home/about-shape1.png'}
                alt={'shape'}
                fill
              />
             </div>
              <div className="card-content">
                <h3 className="title">সফল শীক্ষার্থী</h3>
                <p className="description">
                  আমাদের এ পর্যন্ত সর্বমোট সফল শিক্ষার্থীর সংখ্যা {siteSetting?.before_student ?? 0} জন ।
                </p>
              </div>
            </div>
            <div className="card-item item2">
             <div className='relative w-full h-full'>
               <Image
                src={'/images/home/about-shape2.png'}
                alt={'shape'}
                fill
              />
             </div>
              <div className="card-content">
                <h3 className="title">সর্বমোট কোর্স</h3>
                <p className="description">
                  ফোকাস পরিবারে সর্বমোট কোর্স সংখ্যা {siteSetting?.before_course ?? 0}  টি
                </p>
              </div>
            </div>
            <div className="card-item item3">
             <div className='relative w-full h-full'>
               <Image
                src={'/images/home/about-shape3.png'}
                alt={'shape'}
                fill
              />
             </div>
              <div className="card-content">
                <h3 className="title">অভিজ্ঞ শিক্ষক</h3>
                <p className="description">
                 ফোকাস পরিবারে সর্বমোট অভিজ্ঞ শিক্ষক  {siteSetting?.before_teacher ?? 0} জন
                </p>
              </div>
            </div>
            <div className="card-item item4">
             <div className='relative w-full h-full'>
               <Image
                src={'/images/home/about-shape4.png'}
                alt={'shape'}
                fill
              />
             </div>
              <div className="card-content">
                <h3 className="title">সর্বমোট সাবজেক্ট</h3>
                <p className="description">
                  ফোকাস পরিবারে সর্বমোট সাবজেক্ট সংখ্যা  {siteSetting?.before_subject ?? 0} টি
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
